import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators,FormControl } from '@angular/forms';
import { DashboardService } from '../service/dashboard.service';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';

interface Role {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-signupmanager',
  templateUrl: './signupmanager.component.html',
  styleUrls: ['./signupmanager.component.scss']
})
export class SignupmanagerComponent implements OnInit {

  roles: Role[] = [
    {value: 'manager', viewValue: 'Manager'},
    {value: 'admin', viewValue: 'Admin'},
  ];

  userdata;

  regm={
    email:'',
    firstName:'',
    lastName:'',
    //branch:'',
    new_manager_email:'',
    phone:'',
    role:'admin'
  }
  addmanagerform: FormGroup;

  ghPhonePattern = /^(0)[2354789]\d{8}$/; // Ghana local format: 10 digits starting with 0 and valid network prefix


  constructor(
    public formBuilder: FormBuilder,
    public service: DashboardService, 
    private router:Router) {}


  ngOnInit() {
    this.userdata=JSON.parse(localStorage.getItem('userdata'))
    this.initializeAdminForm()
  }

  initializeAdminForm(){
      this.addmanagerform = this.formBuilder.group({
      firstName: ['', [Validators.required, Validators.maxLength(100)]],
      lastName: ['', [Validators.required, Validators.maxLength(100)]],
      phone: ['', [Validators.required, Validators.pattern(this.ghPhonePattern)]],
      new_manager_email: ['', [Validators.required, Validators.email]],
      role: ['', Validators.required]
    });
  }

  
  regmanager(){
    this.regm = this.addmanagerform.value;

  if(this.addmanagerform.valid) {
     this.regm = this.addmanagerform.value;
     this.regm.email = this.userdata.email;

      // var test = JSON.stringify(this.regm);
      // console.log(this.regm);

      Swal.showLoading();
      this.service.addManager(this.regm)
      .subscribe(response => {
        // console.log(response);
        Swal.close();
        if (response['responseCode'] === '000') {
          this.addmanagerform = this.formBuilder.group({
            firstName: ['', Validators.required],
            lastName: ['', Validators.required],
            branch: ['', Validators.required],
            new_manager_email: ['', Validators.required],
            phone: ['', [Validators.required, Validators.pattern(/^(\+233)[0-9]\d{8}$/)]],
            role: ['', Validators.required],
          });

          this.initializeAdminForm();

            (Swal as any).fire({
              icon:'success',
              title: 'Successful',
              text:'Manager Account Was Created Successfully.',
            });

           this.router.navigate(['/signupmanager'])
        } else {
          (Swal as any).fire({
            icon:'warning',
            title: 'Oops...',
            text: response['responseMessage'],
            footer: ''
          });
        }

      }, error => {
        (Swal as any).fire({
          icon:'error',
          title: 'Oops...',
          text: error,
          footer: ''
        });
        Swal.close();
      })
    } else {
      (Swal as any).fire({
        icon:'warning',
        title: 'Oops...',
        text: 'Please fill all form fields',
        footer: ''
      });
    }

  }


  registermanager(){
    this.router.navigate(['/signupmanager'])
  }


  allmanagers(){
    this.router.navigate(['/allmanagers'])
  }

}
